import { ISearchPage } from '@/types/ScmTypes'
import { iteratee } from 'lodash'

export interface ISupplierSearchFields {
    name?: string
    type?: string
    [key: string]: any
}

export interface ISupplierDetail {
    id: string
    abbreviation: string
    address: string
    category: string
    code: string
    createTime: string
    createUser: string
    developer: string
    developmentDepartment: string
    enable: number
    enterpriseNature: string
    mainProductIntroduction: string
    name: string
    source: string
    sumSupplierInvoicingList: ISupplierInvoiceInfo[] | null
    sumSupplierUserList: ISupplierContacts[] | null
    type: string
    updateTime: string
}

export interface ISupplierFormFields {
    id?: string
    name: string
    code?: string
    abbreviation?: string
    category?: string
    type: string
    developer?: string
    developmentDepartment?: string
    enterpriseNature?: string
    source?: string
    address?: string
    createUser?: string
    updateUser?: string
    mainProductIntroduction?: string
}

export interface ISupplierInsert {
    name: string
    abbreviation?: string
    category?: string
    type: string
    developer?: string
    developmentDepartment?: string
    enterpriseNature?: string
    source?: string
    address?: string
    createUser?: string
    updateUser?: string
    mainProductIntroduction?: string
    sumSupplierInvoicingList: ISupplierInvoiceInfo[]
    sumSupplierUserList: ISupplierContacts[]
}

export interface ISupplierUpdate {
    id: string
    name: string
    abbreviation?: string
    category?: string
    type: string
    developer?: string
    developmentDepartment?: string
    enterpriseNature?: string
    source?: string
    address?: string
    createUser?: string
    updateUser?: string
    mainProductIntroduction?: string
    sumSupplierInvoicingList: ISupplierInvoiceInfo[]
    sumSupplierUserList: ISupplierContacts[]
}

export interface ISupplierContacts {
    id: string
    contacts?: string
    sex?: string
    position?: string
    contactNumber?: string
}

export interface ISupplierInvoiceInfo {
    id: string
    corporateName?: string
    taxId?: string
    companyAddress?: string
    companyPhone?: string
    bankOfDeposit?: string
    bankAccount?: string
}

export interface ISupplierChangeData {
    id: string
    enable: number
}

export interface ISupplierPurchaseHistorySearchFields {
    supplierCode?: string
    materialCode?: string
    materialName?: string
    [key: string]: any
}

// 采购历史数据接口
export interface ISupplierPurchaseHistoryDetail {
    createTime: string // 创建时间
    createUser: string // 创建用户
    id: string // 主键ID
    materialCode: string // 物料编码
    materialName: string // 物料名称
    price: number // 价格
    purchaseCode: string // 采购单号
    shopId: string // 店铺ID
    supplierCode: string // 供应商编码
    supplierName: string // 供应商名称
    [key: string]: any // 其他扩展字段
}

export interface ISupplierSupplyDetailsPageSearchFields {
    code?: string
    [key: string]: any
}

export interface ISupplierSupplyDetails {
    brand: string // 品牌
    createUser: string | null // 创建用户
    id: string // 主键ID
    isPreferredSupplier: number // 是否优选供应商（1-是，0-否）
    manufacturer: string // 制造商
    materialCode: string // 物料编码
    materialName: string // 物料名称
    model: string // 型号
    productLine: string // 产品线
    rebateCategory: string // 返利类别
    supplierCode: string // 供应商编码
    supplierName: string // 供应商名称
    supplyPrice: number // 供应价格
    unit: string // 单位
    variety: string // 品种
    warrantyPeriod: string // 保修期
}

export interface ISupplierContractPageSearchFields {
    supplierCode?: string
    [key: string]: any
}

export interface ISupplierContractDetails {
    id: string
    contractCode?: string // 合同编号
    supplierCode?: string // 供应商编号
    supplierName?: string // 供应商名称
    contractType?: string // 合同类型
    partyASigner?: string // 甲方签约人
    partyBSigner?: string // 乙方签约人
    signDate?: string | moment.Moment // 签约时间
    deadline?: string | moment.Moment // 截止日期
    validityDays?: number // 有效期(天)
    remark?: string // 备注
    createTime?: string // 创建时间
    updateTime?: string // 修改时间
    depositAmount?: number // 授信金额
    rebateType?: string // 返利类型
    attachment?: string // 附件
    [key: string]: any // 其他扩展字段
}

export interface ISupplierContractInsert {
    contractCode?: string // 合同编号
    supplierCode?: string // 供应商编号
    supplierName?: string // 供应商名称
    contractType?: string // 合同类型
    partyASigner?: string // 甲方签约人
    partyBSigner?: string // 乙方签约人
    signDate?: string | moment.Moment // 签约时间
    deadline?: string | moment.Moment // 截止日期
    validityDays?: number // 有效期(天)
    remark?: string // 备注
    createTime?: string // 创建时间
    updateTime?: string // 修改时间
    depositAmount?: number // 授信金额
    rebateType?: string // 返利类型
    attachment?: string // 附件
    [key: string]: any // 其他扩展字段
}

export interface IFmsSupplierBillPageSearch {
    billTimeRange?: {
        startTime?: string | null,
        endTime?: string | null
    },
    partnerCode: string
    partnerTypeCode: string
    page: {
        pageSize: number
        pageNum: number
    }
    sourceApp: string
    [key: string]: any
}

export interface IFmsSupplierBillDetail {
    id: string
    shopCode: string // 采购门店编码
    shopName: string // 采购门店名称
    tradeCode: string // 采购单号
    billAmount: number // 账单金额
    createTime: string // 结算时间
    tradeOperator: string // 操作人
    status: number // 状态：1已记账；2已核销
    writeoffUser: string // 核销人
    writeoffTime: string // 核销时间
    [key: string]: any // 其他扩展字段
}

export interface IFmsSupplierAccountShopPageSearch {
    partnerTypeCode: string
    partnerCode: string
    shopCode: string
    sourceApp: string
}

export interface IFmsSupplierAccountShopDetail {
    id: string
    name: string // 账户名称
    code: string // 账户编号
    accountTypeCode: string // 账户类型编码
    accountTypeName: string // 账户类型名称
    createTime: string // 开户时间
    creditAmount: number // 授信额度
    usedAmount: number // 已用额度
    availableAmount: number // 可用额度
    remainingAmount: number // 剩余金额
    shopCode: string // 门店编号
    shopName: string // 门店名称
    beCode: string // 关联实体编码
    beName: string // 关联实体名称
    [key: string]: any // 其他扩展字段
}

export interface ICommonSearchFields {
    [key: string]: any
}

export interface IFmsDictFindSearch {
    pcode?: string
    sourceApp: string
    [key: string]: any
}

export interface IFmsDictDetail {
    branch?: 'main';                    // 分支
    branchList?: null;                  // 分支列表
    children?: null;                    // 子项
    code?: string;                      // 编码
    dictType?: null;                    // 字典类型
    enable?: number;                    // 启用状态
    key?: string;                       // 键值
    name?: string;                      // 名称
    nameEn?: null;                      // 英文名称
    note?: null;                        // 备注
    pcode?: string;                     // 父编码
    status?: number;                    // 状态
    value?: string;                     // 值
    ver?: number;                       // 版本
    [key: string]: any;                 // 其他扩展字段
}


export interface ISupplierPurchaseInvoiceSearchFields{
    billTimeRange?: {
        startTime?: string,
        endTime?: string
    }
}


export const repairQualificationOptions = [
    {label: "一类", key: "1", value: "1"},
    {label: "二类", key: "2", value: "2"},
    {label: "三类", key: "3", value: "3"}
]

export const partsDemandLevelOptions = [
    {label: "一类", key: "1", value: "1"},
    {label: "二类", key: "2", value: "2"},
    {label: "三类", key: "3", value: "3"}
]

export const siteConditionSummaryOptions = [
    {label: "有工位", key: "1", value: "1"},
    {label: "有费油回收", key: "2", value: "2"},
    {label: "有钣喷", key: "3", value: "3"},
]

export const keyFocusAreasOptions= [
    {label: "质量", key: "1", value: "1"},
    {label: "品牌", key: "2", value: "2"},
    {label: "价格", key: "3", value: "3"},
    {label: "服务", key: "4", value: "4"},
    {label: "时效", key: "5", value: "5"},
    {label: "账期", key: "6", value: "6"},
    {label: "齐全", key: "7", value: "7"},
    {label: "准确", key: "8", value: "8"},
]



